// extracted by mini-css-extract-plugin
export default {"testInfo":"TestInfo_testInfo__DRB3v"};